import styled from '@emotion/styled';
export const Wrapper = styled.div `
  background: var(--gray3);
  padding: 12px;
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  gap: 12px;
  text-align: center;
  position: relative;
`;
export const Message = styled.div `
  font-family: var(--font-family);
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: white;
  margin-bottom: 30px;
`;
